import React, {Component} from 'react';
import { translate } from "react-translate"
import {Grid, Icon} from 'semantic-ui-react';
import Separator from './DevisSeparator';
import SideRowOptions from './SideRowOptions';
import {defaultColumnWidth, nameColumnWidth, lastColumnWidth} from './Constants';
import {EditableField} from './EditableField';


class DevisRow extends Component {
    constructor(props){
        super(props);
        this.state = {}
    }

    render(){
        const divided = !(this.props.type == 'category' || this.props.type == 'subcategory');
        const handleChange = this.props.handleChangeRow || function(){}
        return(
        <Grid>
        <Grid.Row
            id ={this.props.id} 
            onClick={() => this.props.handleClick ? this.props.handleClick(this.props) : function(){}}
            divided={divided} 
            className={((this.props.prefix || '').length === 0 ? 'striped' : 'sub' + ' nested' + (this.props.prefix || '').length) + (this.props.editing ? ' edit' : '')}
        >      
            { // ARROWS UP AND DOWN WHEN EDITING MODE IS ON
                this.props.editing ? (
                    <div className="arrowCmd">
                        <Icon name="angle up" centered="true" onClick={(e) => this.props.handleMoveUp ? this.props.handleMoveUp(e, this.props) : function(){}}/>
                        <Icon name="angle down" centered="true" onClick={(e) => this.props.handleMoveDown ? this.props.handleMoveDown(e, this.props) : function(){}}/>
                    </div>
                ) : (null)
            }
            <Grid.Column width={defaultColumnWidth}>
                {(this.props.prefix || "") + this.props.number}
            </Grid.Column>
            <Grid.Column width={nameColumnWidth}>
                <EditableField onChange={(val) => {handleChange(this.props, 'name', val)}} content={this.props.name} />
                <EditableField onChange={(val) => {handleChange(this.props, 'description', val)}} className='desc' content={this.props.description} />
            </Grid.Column>
            <Grid.Column width={defaultColumnWidth}>
                {divided && <EditableField inlined content = {(this.props.quantity || '')} />}
                {divided && <EditableField inlined content= {(this.props.quantityUnit|| '')} /> }
            </Grid.Column>
            <Grid.Column width={defaultColumnWidth}>
                {divided && <EditableField content= {this.props.unitPrice ? this.props.unitPrice + "€"  : ''} />}
            </Grid.Column>
            <Grid.Column width={defaultColumnWidth}>
                {divided && <EditableField content= {this.props.vat ? this.props.vat + "%" : ''} />}
            </Grid.Column>
            <Grid.Column width={lastColumnWidth}>
                {"TODO €"}
            </Grid.Column>
            { // OPTIONS ON THE RIGHT OF THE ROW WHEN EDITING MODE IS ON
                this.props.editing ? (
                    <SideRowOptions
                        row={{...this.props}}
                        onInsertLineAbove={this.props.onInsertLineAbove}
                        onInsertPageJumpAbove={this.props.onInsertPageJumpAbove}
                        onDelete={this.props.onDelete}
                    />
                ) : (null)
            }
        </Grid.Row>
        {
            // SEPARATOR IF WE HAVE CHILDREN
            (this.props.childrenRows || []).length > 0 ? ( <Separator />) : (<div/>)
        }
        {
            (this.props.childrenRows || []).map((row, i) => (
                <DevisRow 
                    prefix = {(this.props.prefix || '') +  (this.props.number ? this.props.number + '.' : '')}
                    key={i}
                    number={row.number}
                    name={row.name}
                    quantity={row.quantity}
                    quantityUnit={row.quantityUnit}
                    unitPrice={row.unitPrice}
                    vat={row.vat}
                    totalPrice={row.totalPrice}
                    description={row.description}
                    type={row.type}
                    childrenRows = {row.children}
                    handleClick={(e, rowProps) => this.props.handleClick(e, rowProps)}
                    handleMoveUp={(e, rowProps) => this.props.handleMoveUp(e, rowProps)}
                    handleMoveDown={(e, rowProps) => this.props.handleMoveDown(e, rowProps)}
                    onInsertLineAbove={this.props.onInsertLineAbove}
                    onInsertPageJumpAbove={this.props.onInsertPageJumpAbove}
                    onDelete={this.props.onDelete}
                    editing={row.editing}
                    handleChangeRow={this.props.handleChangeRow}
                    last = { (i+1) ==  (this.props.childrenRows || []).length}
                />
            ))
        }
        {
            // MED SEPARATOR IF WE ARE THE LAST CHILD
            (this.props.last && (this.props.prefix || '').length > 0 ) ? ( <Separator medium />) : (<div/>)
        }
        {
            // TOP LEVEL Row, bottom separator, except for last top tier comp (above totals)
            (this.props.childrenRows || []).length > 0 
            && (this.props.prefix || '').length == 0 
            && !this.props.last ? 
                ( <Separator medium />) : (null)
        }
        </Grid>
        );
    }
}


export default translate("ProEditDevisRow")(DevisRow)


// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/EditionDevisFactures/DevisComp/DevisRow.jsx